module.exports = __webpack_public_path__ + "img/img-c1c82a.png";